import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const CustomerUserProfileInfoComponent = ({onInnerFormChange, selectedCustomers }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedCustomers?.UserProfile
                )
              }}
              type="text"
              value={selectedCustomers?.UserProfile?.FirstName}
          />
       <InputContainer
              label="Last Name"
              name="LastName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedCustomers?.UserProfile
                )
              }}
              type="text"
              value={selectedCustomers?.UserProfile?.LastName}
          />
      <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedCustomers?.UserProfile
                )
              }}
              type="text"
              value={selectedCustomers?.UserProfile?.Email}
          />
    <InputContainer
              label="ProfilePicture Url"
              name="ProfilePictureUrl"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'UserProfile.ProfilePictureUrl',
                  selectedCustomers?.UserProfile
                )
              }}
              type="text"
              value={selectedCustomers?.UserProfile?.ProfilePictureUrl}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
</>
)
export default CustomerUserProfileInfoComponent;
